import { PRESENTATIONS } from '../../constants/endpoints';
import useMutateApi from '../../api/hooks/useMutateApi';

const useStopPresentation = (spaceId, presentationId, config) =>
  useMutateApi(
    {
      url: `${PRESENTATIONS()}/${spaceId}/presentations/${presentationId}/stop`,
      method: 'POST',
    },
    config
  );
export default useStopPresentation;
